<template>
  <div>
    <v-container fluid pa-0 grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h2 class="headline">Manage Users</h2>
              <v-spacer />
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                color="#0b2a4a"
              >
                <template v-slot:append>
                  <v-icon>search</v-icon>
                </template>
              </v-text-field>
            </v-card-title>
            <v-flex xs12>
              <h3>Groups</h3>
              <ul>
                <li>User: Read-only access to search and view users</li>
                <li>Admin: Read-write access to search and view users, create sponsors</li>
                <li>DeleteUsers: Admin capability plus allow deleting users</li>
                <li>Super: Manage MALA users and groups</li>
              </ul>
            </v-flex>
            <v-data-table
              :headers="headers"
              :items="accounts"
              :rows-per-page-items="[15]"
              class="elevation-1 table-striped my-3"
              :pagination.sync="pagination"
              :search="search"
              :loading="searchLoading ? appButtonColor : searchLoading"
              :no-data-text="loadingText"
            >
              <template slot="items" slot-scope="props">
                <tr class="row">
                  <td>{{ props.item.prefUsername ? props.item.prefUsername : props.item.username }}</td>
                  <td>{{ props.item.enabled ? "Active" : "Inactive" }}</td>
                  <td>{{ props.item.userStatus }}</td>
                  <!-- <td>{{ props.item.firstName }}</td>
                  <td>{{ props.item.lastName }}</td>-->
                  <td>{{ props.item.email }}</td>
                  <td>
                    <v-select
                      class="py-1"
                      :color="appButtonColor"
                      :value="props.item.group"
                      :items="userPerms"
                      :ref="props.item.username"
                      @change="editUserGroup(props.item, $event)"
                      :errorMessages="props.item.error ? 'Error updating': ''"
                    ></v-select>
                  </td>
                  <td>
                    <v-icon color="red" @click.stop="deleteUser(props.item.username)">cancel</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
        <confirm ref="confirm"></confirm>
        <vue-snotify></vue-snotify>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapState, mapGetters } from "vuex";
import Confirm from "@/components/Confirm.vue";
export default {
  name: "Manage",
  components: {
    Confirm
  },
  data() {
    return {
      searchLoading: true,
      groupError: false,
      permSuccess: false,
      search: "",
      userPerms: ["Super", "Admin", "DeleteUsers", "User"],
      headers: [
        { text: "Username", sortable: true, value: "username" },
        { text: "Account", sortable: true, value: "enabled" },
        { text: "Status", sortable: true, value: "userStatus" },
        // { text: "First Name", sortable: true, value: "firstName" },
        // { text: "Last Name", sortable: true, value: "lastName" },
        {
          text: "Email",
          sortable: true,
          value: "email"
        },
        { text: "Permission", sortable: true, value: "group" }
      ],
      pagination: {
        descending: false,
        sortBy: "username"
      }
    };
  },
  computed: {
    ...mapState("user", ["user", "state", "confirmed", "mersBranded"]),
    ...mapState("accounts", ["accounts"]),
    ...mapGetters("user", ["isAuthenticated", "userGroup", "adminOrSuper"]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    loadingText() {
      if (this.searchLoading) return "Loading Users";
      else return "No Users Found";
    }
  },
  async created() {
    await this.$store.dispatch("accounts/getUsers");
    this.searchLoading = false;
  },
  methods: {
    async editUserGroup(user, val) {
      let ind = this.accounts.findIndex(
        item => item.username === user.username
      );

      this.$store.commit("accounts/setError", {
        bool: false,
        user: ind
      });

      let result = await this.$store.dispatch("accounts/changeUserGroup", {
        username: user.username,
        addGroup: val,
        removeGroup: user.group
      });

      if (result) {
        this.$store.commit("accounts/updateUserGroup", {
          ind,
          group: val
        });
      } else {
        this.$store.commit("accounts/updateUserGroup", {
          ind,
          group: user.group
        });
        this.$store.commit("accounts/setError", {
          bool: true,
          user: ind
        });
        this.$refs[user.username].lazyValue = user.group;
      }
    },
    /**
     * Delete MALA user from Cognito
     * @param {*} username 
     */
    async deleteUser(username) {
      if (await this.$refs.confirm.open('Delete User', 'Are you sure?', { color: 'red' })) {
        let result = await this.$store.dispatch("accounts/deleteMalaUser", {
          username: username
        })

        if (result) {
          this.$store.commit("accounts/removeMalaUserFromList", { username })
          this.displayNotification("success", "User Deleted");
        } else {
          this.displayNotification("error", "Error Deleting User");
        }
      }
    },
    /**
     * Display a notification
     * @param {*} type 
     * @param {*} notification 
     */
    displayNotification(type, notification) {
      if (type === "success") {
        this.$snotify[type](`${notification}`);
      } else {
        this.$snotify[type](`${notification}`, "", {
          timeout: 0,
        });
      }
    },
  }
};
</script>

<style lang="scss">
</style>
